import type { Components, Theme } from '@mui/material/styles';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  defaultProps: { variant: 'body1', color: 'neutral.900' },
};
